import { render, staticRenderFns } from "./VideosPage.vue?vue&type=template&id=607ff504&scoped=true"
import script from "./VideosPage.vue?vue&type=script&lang=ts"
export * from "./VideosPage.vue?vue&type=script&lang=ts"
import style0 from "./VideosPage.vue?vue&type=style&index=0&id=607ff504&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607ff504",
  null
  
)

export default component.exports